import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { StockActionTypes } from './constants';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { stock, stockCreate, stockUpdate, findTagInStock } from './api';
/**
 * @param {*} payload 
 */

function* stockDataGetFunction(data) {
    try {
        yield put({
            type: StockActionTypes.STOCK_DATA_LOADING,
            payload: {},
        });
        const response = yield call(stock, data);
        if (response.data.status) {
            yield put({
                type: StockActionTypes.STOCK_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response.data.message);
            yield put({
                type: StockActionTypes.STOCK_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: StockActionTypes.STOCK_DATA_ERROR,
            payload: error,
        });
    }
}

function* stockDataCreateFunction(data) {
    try {
        yield put({
            type: StockActionTypes.CREATE_STOCK_DATA_LOADING,
            payload: {},
        });
        const response = yield call(stockCreate, data);
        if (response.data.status) {
            yield put({
                type: StockActionTypes.CREATE_STOCK_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response.data.message);
            yield put({
                type: StockActionTypes.CREATE_STOCK_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: StockActionTypes.CREATE_STOCK_DATA_ERROR,
            payload: error,
        });
    }
}

function* stockDataUpdateFunction(data) {
    try {
        yield put({
            type: StockActionTypes.UPDATE_STOCK_DATA_LOADING,
            payload: {},
        });
        const response = yield call(stockUpdate, data);
        if (response.data.status) {
            yield put({
                type: StockActionTypes.UPDATE_STOCK_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response.data.message);
            yield put({
                type: StockActionTypes.UPDATE_STOCK_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: StockActionTypes.UPDATE_STOCK_DATA_ERROR,
            payload: error,
        });
    }
}
function* findTagInStockFunction(data) {
    try {
        yield put({
            type: StockActionTypes.FIND_TAG_IN_STOCK_LOADING,
            payload: {},
        });
        const response = yield call(findTagInStock, data);
        if (response.data.status) {
            yield put({
                type: StockActionTypes.FIND_TAG_IN_STOCK_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response.data.message);
            yield put({
                type: StockActionTypes.FIND_TAG_IN_STOCK_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: StockActionTypes.FIND_TAG_IN_STOCK_ERROR,
            payload: error,
        });
    }
}


<ToastContainer autoClose={2000} />

export function* watchstockData() {
    yield takeLatest(StockActionTypes.STOCK_DATA_FIRST, stockDataGetFunction)
    yield takeEvery(StockActionTypes.CREATE_STOCK_DATA_FIRST, stockDataCreateFunction)
    yield takeLatest(StockActionTypes.UPDATE_STOCK_DATA_FIRST, stockDataUpdateFunction)
    yield takeLatest(StockActionTypes.FIND_TAG_IN_STOCK_FIRST, findTagInStockFunction)
}

function* stockSaga() {
    yield all([
        fork(watchstockData),
    ]);
}
export default stockSaga;
